import { ActionTypes } from "@/App/constants/actionTypes";
import { BatchTestClaimTypes, GeneralTypes } from "@/types";

type GetTestClaimListAction = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST;
  payload: {
    queryOptions: GeneralTypes.QueryOptions;
  };
};

export const getTestClaimList = (data: { queryOptions: GeneralTypes.QueryOptions }): GetTestClaimListAction => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST,
    payload: data,
  };
};

type GetTestClaimListResultAction = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST_RESULTS;
  payload: {
    results: Array<BatchTestClaimTypes.BatchTestClaim>;
    result_count: string;
  };
};

export const getTestClaimListResults = (data: {
  results: Array<BatchTestClaimTypes.BatchTestClaim>;
  result_count: string;
}): GetTestClaimListResultAction => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST_RESULTS,
    payload: data,
  };
};

export type GetBatchTestClaimListActions = GetTestClaimListAction | GetTestClaimListResultAction;
